import script from "./Image.vue?vue&type=script&lang=ts&setup=true"
export * from "./Image.vue?vue&type=script&lang=ts&setup=true"

import "./Image.vue?vue&type=style&index=0&id=2c69001a&lang=less&scoped=true"
import "./Image.vue?vue&type=style&index=1&id=2c69001a&lang=less"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c69001a"]])

export default __exports__